import { PageHero } from "../components/PageHero";
import { Programs } from "../components/Programs";
import { Services } from "../components/Services";
import { Timeline } from "../components/Timeline";
import { CTABand } from "../components/CTABand";

export default function Courses({ onApply }) {
  return (
    <>
      <PageHero media="/videos/clip2.mp4" overline="Courses & Services" title="Every rating on your" highlight="pathway to the airlines." subtitle="From your first discovery flight to a commercial licence, instrument and multi-engine ratings — plus the services that make training seamless." />
      <Programs showHeader={false} onCardClick={onApply} cta="Enquire" />
      <Services />
      <Timeline />
      <CTABand onApply={onApply} title="Not sure which course is right for you?" text="Talk to our admissions team and we'll map out a training plan tailored to your goals and budget." />
    </>
  );
}
